import React from "react";
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";

export interface RowAction {
    icon: string;
    label: string;
    onClick: () => void;
    hidden?: boolean;
    danger?: boolean;
}

/** The "⋯" row menu every list in the app uses (see Content/QuickAnswer/tableColumns). */
const RowActions = ({ actions }: { actions: (RowAction | 'divider')[] }) => {
    const visible = actions.filter((a) => a === 'divider' || !a.hidden);
    if (!visible.some((a) => a !== 'divider')) {
        return null;
    }

    return (
        <UncontrolledDropdown className="dropdown d-inline-block">
            <DropdownToggle className="btn btn-light btn-sm" tag="button">
                <i className="ri-more-fill align-middle" />
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end" container="root">
                {visible.map((a, i) => a === 'divider'
                    ? <DropdownItem key={'d' + i} divider />
                    : (
                        <DropdownItem key={a.label} className={a.danger ? 'remove-item-btn' : undefined} onClick={a.onClick}>
                            <i className={a.icon + ' align-bottom me-2 ' + (a.danger ? 'text-danger' : 'text-muted')} /> {a.label}
                        </DropdownItem>
                    ))}
            </DropdownMenu>
        </UncontrolledDropdown>
    );
};

/** The first column that holds RowActions, as in the app's other lists. */
export const actionsColumn = <T,>(render: (row: T) => React.ReactNode) => ({
    name: <i className="ri-settings-4-line text-muted" />,
    width: '50px',
    allowOverflow: true,
    center: true,
    ignoreRowClick: true,
    cell: render,
});

export default RowActions;
